"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var mobx_react_1 = require("mobx-react");
var removePhraseFromClause_1 = require("../actions/helpers/removePhraseFromClause");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var isValidClause_1 = require("../utils/isValidClause");
var setClauseErrorText_1 = require("../actions/helpers/setClauseErrorText");
var styles = require('./PhrasePill.scss');
/*
Phrase pills are used in the 'includes these words' clauses for inbox rules.
A user enters text in the input and presses enter to commit the phrase and
create a phrase pill
*/
var PhrasePill = /** @class */ (function (_super) {
    tslib_1.__extends(PhrasePill, _super);
    function PhrasePill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PhrasePill.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: styles.phrasePill },
            React.createElement("span", { className: styles.phrasePillText }, this.props.phrase),
            React.createElement(Button_1.IconButton, { className: styles.phrasePillClose, iconProps: {
                    iconName: "Cancel" /* Cancel */,
                    styles: {
                        root: styles.cancelIcon,
                    },
                }, onClick: function () {
                    removePhraseFromClause_1.default(_this.props.clauseId, _this.props.phrase);
                    setClauseErrorText_1.default(_this.props.clauseId, isValidClause_1.default(_this.props.clauseId));
                } })));
    };
    PhrasePill = tslib_1.__decorate([
        mobx_react_1.observer
    ], PhrasePill);
    return PhrasePill;
}(React.Component));
exports.default = PhrasePill;
//# sourceMappingURL=PhrasePill.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/components/PhrasePill.js
// module id = 5190
// module chunks = 2